import noop from 'lodash/noop';
import React, { useContext } from 'react';

import { RouteComponentProps, withRouter } from 'react-router';
import { BankPersonalization as IBankPersonalization, useBankPersonalizationInternal } from './UseBankPersonalization';

const initialContext: IBankPersonalization = {
  bankPersonalization: undefined,
  setBankPersonalization: noop,
};

const BankPersonalization = React.createContext<IBankPersonalization>(initialContext);
BankPersonalization.displayName = 'BankPersonalization';

export const useBankPersonalization = () => useContext(BankPersonalization);

export interface IBankPersonalizationProvider {
  history: RouteComponentProps['history'];
}

const BankPersonalizationProvider: React.FC<IBankPersonalizationProvider> = ({ children, history }) => {
  return (
    <BankPersonalization.Provider value={useBankPersonalizationInternal(history)}>
      {children}
    </BankPersonalization.Provider>
  );
};

const Wrapped = withRouter(BankPersonalizationProvider);
export { Wrapped as BankPersonalizationProvider };

export const BankPersonalizationConsumer = BankPersonalization.Consumer;
